import SourceCategorySort from 'SourceComponent/CategorySort/CategorySort.container';
import { connect } from 'react-redux';

export const mapStateToProps = state => ({
    totalItems: state.ProductListReducer.totalItems,
});

export class CategorySortContainer extends SourceCategorySort {
    _getLabel(option) {
        const { id, label: pureLabel } = option;

        switch (id) {
        case 'price':
            return {
                asc: __('%s ascending', pureLabel),
                desc: __('%s descending', pureLabel)
            };
        case 'top_seller_alt':
            return {
                desc: __('Top Seller descending')
            };
        case 'most_reviewed_alt':
            return {
                desc: __('Most Reviewed descending')
            };
        case 'top_rated_alt':
            return {
                desc: __('Top Rated descending')
            };
        case 'position':
            return {
                asc: __('Recommended')
            };
        default:
            return {
                asc: pureLabel
            };
        }
    }
}

export default connect(mapStateToProps)(CategorySortContainer);
